export const AdminReservationSlotController = {
    index(): void {},
    create(): void {},
    store(): void {},
    edit(): void {},
    update(): void {},
    updateStatus(): void {},
    bulkDestroy(): void {},
    destroy(): void {},
};
